import { useTranslator } from "../../i18n/context.js";
import { renderElement } from "../../utils/use-render.js";
import { useDialogContext } from "../dialog/context.js";
import { getErrorDialogDismissText } from "@videojs/core";
import { translateText } from "@videojs/core/i18n";
import { forwardRef, useCallback } from "react";
//#region src/ui/error-dialog/close.tsx
/** Renders a localized button that closes the dialog and dismisses the player error. */
const ErrorDialogClose = forwardRef(function ErrorDialogClose({ render, className, style, disabled, children, ...elementProps }, forwardedRef) {
	const t = useTranslator();
	const { dialog, state, stateAttrMap } = useDialogContext();
	const handleClick = useCallback(() => {
		if (disabled) return;
		dialog.close();
	}, [dialog, disabled]);
	const content = children ?? translateText(getErrorDialogDismissText(), t);
	return renderElement("button", {
		render,
		className,
		style
	}, {
		state,
		stateAttrMap,
		ref: forwardedRef,
		props: [{
			type: "button",
			disabled,
			onClick: handleClick,
			children: content
		}, elementProps]
	});
});
//#endregion
export { ErrorDialogClose };

//# sourceMappingURL=close.js.map